import { setCurrentLocaleCode } from "@mongez/localization";
import { useLocation, useNavigate } from "@remix-run/react";

export function useLocaleCode() {
  const location = useLocation();

  if (!location.pathname) {
    return "";
  }

  return location.pathname.split("/")[1];
}

export function useChangeLocaleCode() {
  const currentLocaleCode = useLocaleCode();
  const location = useLocation();
  const navigate = useNavigate();

  const languages = ["english", "arabic"];

  const newLocaleCode = currentLocaleCode === "en" ? "ar" : "en";

  const changeLanguage = () => {
    setCurrentLocaleCode(newLocaleCode);

    // Build the complete URL with query parameters and hash
    const newPathname = location.pathname.replace(`/${currentLocaleCode}`, `/${newLocaleCode}`);
    const fullUrl = newPathname + location.search + location.hash;

    navigate(
      fullUrl,
      { preventScrollReset: true, viewTransition: true },
    );
  };

  return {
    currentLocaleCode,
    changeLanguage,
    languages,
  };
}
